module.exports = __webpack_public_path__ + "static/media/banner2.aaf72d2e.jpg";